import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateAccountMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountInput;
}>;

export type CreateAccountMutationResult = { __typename?: 'Mutation' } & {
  createAccount?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountPayload' } & Pick<GraphQLTypes.CreateAccountPayload, 'accountId'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      }
  >;
};

export const CreateAccountDocument = gql`
  mutation createAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      accountId
      errors {
        message
        path
      }
    }
  }
`;
